import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		warningIcon: {
			color: theme.palette.custom.tagWarningText,
			flexShrink: 0,
		},
		body: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		text: {
			fontSize: 18,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		// Teal, with the external-link icon; DialogLink adds the underline.
		link: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(0.5),
			color: theme.palette.custom.tertiaryAction,
		},
	} satisfies Record<string, CSSObject>);
};
